import { BsArrowBarDown, BsArrowBarUp } from 'react-icons/bs';
import { Container } from 'react-bootstrap';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { generalBlue } from 'src/app-config';
import { HTHFace } from './HTHSectionFace';
import { HTHSectionMap } from './HTHSectionMap';
import { typeBlock, typeFace, typeHTHTerritory, typeHTHFace, typeTerritoryNumber } from '@monorepo/models';
import { useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    currentFace: typeHTHFace | null;
    hthTerritory: typeHTHTerritory;
    setCurrentFace: Dispatch<SetStateAction<typeHTHFace | null>>;
    setHTHTerritory: Dispatch<SetStateAction<typeHTHTerritory | null>>;
    territoryNumber: typeTerritoryNumber;
};

export const HTHSection: FC<propsType> = ({
    currentFace, hthTerritory, setCurrentFace, setHTHTerritory, territoryNumber
}) => {
    const [isAddingNewBlock, setIsAddingNewBlock] = useState(false);
    const [isAddingNewFace, setIsAddingNewFace] = useState(false);
    const [isCompletingNewBlock, setIsCompletingNewBlock] = useState(false);
    const [isEditingView, setIsEditingView] = useState(false);
    const [showMapSection, setShowMapSection] = useState(false);
    const [showNewFaceOptions, setShowNewFaceOptions] = useState(false);
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    
    const selectBlockAndFaceHandler = (selectedBlock?: typeBlock, selectedFace?: typeFace, _hthTerritory: typeHTHTerritory | null = null) => {
        if (selectedBlock === undefined && selectedFace === undefined) {
            setCurrentFace(null);
        }
        if (!selectedBlock || !selectedFace || !hthTerritory || !hthTerritory.faces) {
            return;
        }
        const target = _hthTerritory ?? hthTerritory
        let _currentFace = target.faces.find(x => x.block === selectedBlock && x.face === selectedFace);
        if (!_currentFace) {
            return;
        }
        if (_currentFace.doNotCalls) {
            _currentFace.doNotCalls = _currentFace.doNotCalls.sort((d1, d2) => d1.streetNumber - d2.streetNumber);
        }
        if (_currentFace.observations) {
            _currentFace.observations = _currentFace.observations.reverse();
        }
        if (_currentFace) {
            setCurrentFace(_currentFace);
        }
    }

    return (
        <>
        <Container>
            <h1 className={'container pointer btn-general-blue text-white py-3'}
                style={{
                    backgroundColor: generalBlue,
                    fontSize: isMobile ? '1.8rem' : '2.4rem',
                    fontWeight: 'bold',
                    margin: isMobile ? '30px auto 40px auto' : '60px auto 40px auto',
                    // maxWidth: '90%',
                    textAlign: 'center'
                }}
                onClick={() => {
                    setShowMapSection(x => !x);
                    setIsEditingView(false);
                }}
            >
                {showMapSection ?
                    <>OCULTAR MAPA <BsArrowBarUp size={isMobile ? '1.6rem' : '1.4rem'} /></>
                    :
                    <>VER MAPA <BsArrowBarDown size={isMobile ? '1.6rem' : '1.4rem'} /></>
                }
            </h1>
        </Container>
        {showMapSection && !isAddingNewBlock && !isAddingNewFace && !isEditingView &&
            <h1 className={`text-center fw-bolder ${isDarkMode ? 'text-white' : ''} mt-3 mb-4`}>
                SELECCIONAR CARA DE MANZANA
            </h1>
        }
        {showMapSection &&
            <>
            <div className={'mb-5'}>
                <HTHSectionMap
                    currentFace={currentFace}
                    hthTerritory={hthTerritory}
                    isAddingNewBlock={isAddingNewBlock}
                    isAddingNewFace={isAddingNewFace}
                    isCompletingNewBlock={isCompletingNewBlock}
                    isEditingView={isEditingView}
                    selectBlockAndFaceHandler={selectBlockAndFaceHandler}
                    setHTHTerritory={setHTHTerritory}
                    setIsAddingNewBlock={setIsAddingNewBlock}
                    setIsAddingNewFace={setIsAddingNewFace}
                    setIsCompletingNewBlock={setIsCompletingNewBlock}
                    setIsEditingView={setIsEditingView}
                    setShowNewFaceOptions={setShowNewFaceOptions}
                    showNewFaceOptions={showNewFaceOptions}
                    territoryNumber={territoryNumber}
                />
            </div>
            {currentFace &&
                <HTHFace
                    currentFace={currentFace}
                    hthTerritory={hthTerritory}
                    territoryNumber={territoryNumber}
                />
            }
            </>
        }
        </>
    );
}
